
'use strict';

var $ = require('jquery'),
  BrowseView = require('./BrowseView'),
  ReferenceDesignBrowseBarView = require('./ReferenceDesignBrowseBarView'),

  // Create manufacturers tabs
  browseBar = new ReferenceDesignBrowseBarView({
    el: '#referenceDesignsBrowseBar',
    $dataEl: $('.ReferenceDetail-header')
  });

if ($('.js-reference-browseTabs').length) {

  // Create Application Drawer
  var browseView = new BrowseView({
    el: '.js-reference-browseTabs'
  });

  browseView.listenTo(browseBar, 'change:tab', browseView.switchTab);
  browseView.listenTo(browseBar, 'change:filter', browseView.switchFilter);

}



// WEBPACK FOOTER //
// ./assets/js/reference/reference.js